/**
 * SENSHI BAG — VARIANT MODEL (PDP)
 * Inner Print × Strap Colour are two options of one product. Selecting them
 * resolves the matching variant, sets the form's variant id, swaps the gallery
 * photo to the variant image, and optionally adds an Embroidery line item.
 * Opens the theme's cart drawer after add (falls back to /cart when absent).
 */
import Cart from 'cart-store';

(function () {
  'use strict';

  var configEl = document.getElementById('senshi-variants-config');
  if (!configEl) return;

  var config;
  try { config = JSON.parse(configEl.textContent); } catch (e) { console.error('[Senshi] config parse error', e); return; }
  if (!config || !config.isSenshiBag) return;

  var variants = config.variants || [];

  var root = document.getElementById('senshi-bag-variants');
  var form = document.querySelector('.js-product-form');
  if (!root || !form) return;

  var printSwatches = root.querySelectorAll('#senshi-print-swatches .senshi-swatch');
  var strapSwatches = root.querySelectorAll('#senshi-strap-swatches .senshi-swatch');
  var printSelected = document.getElementById('senshi-print-selected');
  var strapSelected = document.getElementById('senshi-strap-selected');
  var hasColour = strapSwatches.length > 0;

  var ENGLISH_ONLY = /^[A-Za-z0-9 \-'.]*$/;
  function stripNonEnglish(str) { return str.replace(/[^A-Za-z0-9 \-'.]/g, ''); }

  var currentVariant = null;

  // ── Selection readers ──
  function selectedPrint() {
    var r = root.querySelector('input[name="senshi-print"]:checked');
    return r ? r.value : null;
  }
  function selectedColour() {
    if (!hasColour) return '';
    var r = root.querySelector('input[name="senshi-strap-colour"]:checked');
    return r ? r.value : null;
  }

  function resolveVariant() {
    var p = selectedPrint();
    var c = selectedColour();
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.print === p && (v.colour === c || !v.colour)) return v;
    }
    return null;
  }

  // ── Gallery photo swap (uses the theme's media-gallery) ──
  function swapGallery(mediaId) {
    if (!mediaId) return;
    var gallery = document.querySelector('media-gallery');
    if (gallery && typeof gallery.goToSlide === 'function') gallery.goToSlide(mediaId);
  }

  // ── Price ──
  // Formats in the shopper's active currency (correct symbol + decimals),
  // e.g. $158.00 / €145.00 / ₩158,000. Keeps a trailing code (e.g. "AUD") if the theme shows one.
  var priceEl = document.querySelector('.product-single__box__block--price .price__number--sale .money')
             || document.querySelector('.product-single__box__block--price .money');
  var currencyCode = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || null;
  var priceCurrencySuffix = '';
  if (priceEl) {
    var m = priceEl.textContent.trim().match(/\d([^\d]*)$/);
    if (m && m[1] && /[A-Za-z]/.test(m[1])) priceCurrencySuffix = m[1].trim();
  }
  var moneyFormatter = null;
  if (currencyCode && window.Intl && Intl.NumberFormat) {
    var locale = document.documentElement.lang || undefined;
    try { moneyFormatter = new Intl.NumberFormat(locale, { style: 'currency', currency: currencyCode, currencyDisplay: 'narrowSymbol' }); }
    catch (e) {
      try { moneyFormatter = new Intl.NumberFormat(locale, { style: 'currency', currency: currencyCode }); }
      catch (e2) { moneyFormatter = null; }
    }
  }
  function formatMoney(cents) {
    var amount = cents / 100;
    var suffix = priceCurrencySuffix ? ' ' + priceCurrencySuffix : '';
    if (moneyFormatter) return moneyFormatter.format(amount) + suffix;
    return '$' + amount.toFixed(2) + suffix;
  }
  function updatePrice() {
    if (!priceEl) return;
    var base = currentVariant ? currentVariant.price : 0;
    var addOn = (embToggle && embToggle.checked) ? (config.embroideryPrice || 0) : 0;
    priceEl.textContent = formatMoney(base + addOn);
  }

  // ── Grey out prints with no available variant in any strap colour (matches homepage) ──
  function updatePrintAvailability() {
    printSwatches.forEach(function (sw) {
      var r = sw.querySelector('input[type="radio"]');
      var p = r ? r.value : null;
      var available = false;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].print === p && variants[i].available) { available = true; break; }
      }
      sw.classList.toggle('senshi-swatch--soldout', !available);
      sw.dataset.available = available ? 'true' : 'false';
      sw.title = (p || '') + (available ? '' : ' (Sold out)');
    });
  }

  // ── Grey out colours with no available variant for the selected print ──
  function updateColourAvailability() {
    if (!hasColour) return;
    var p = selectedPrint();
    strapSwatches.forEach(function (sw) {
      var colour = sw.dataset.colour;
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].print === p && variants[i].colour === colour) { match = variants[i]; break; }
      }
      var available = match ? match.available : false;
      sw.classList.toggle('senshi-swatch--soldout', !available);
      sw.dataset.available = available ? 'true' : 'false';
    });
  }

  // ── Strap preview (photo of selected colour) + embroidery text overlay ──
  var strapImages = {};
  var siEl = root.querySelector('#senshi-strap-images');
  if (siEl) { try { strapImages = JSON.parse(siEl.textContent) || {}; } catch (e) { strapImages = {}; } }
  var strapTextStyles = {};
  var stsEl = root.querySelector('#senshi-strap-text-style');
  if (stsEl) { try { strapTextStyles = JSON.parse(stsEl.textContent) || {}; } catch (e) { strapTextStyles = {}; } }
  var strapPreview = root.querySelector('[data-senshi-strap-preview]');
  var strapPreviewImg = root.querySelector('[data-senshi-strap-preview-img]');
  var strapPreviewText = root.querySelector('[data-senshi-strap-preview-text]');
  var STRAP_TEXT_PLACEHOLDER = 'JOHN';

  // ── Embroidery text colour (thread) — overrides the auto strap colour in the preview ──
  var threadGroup = root.querySelector('[data-thread-group]');
  function selectedThreadName() {
    var r = threadGroup && threadGroup.querySelector('input[type="radio"]:checked');
    return r ? r.value : '';
  }
  function selectedThreadHex() {
    var r = threadGroup && threadGroup.querySelector('input[type="radio"]:checked');
    var sw = r && r.closest('.senshi-thread-swatch');
    return sw ? (sw.getAttribute('data-hex') || '') : '';
  }
  if (threadGroup) {
    threadGroup.querySelectorAll('.senshi-thread-swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        threadGroup.querySelectorAll('.senshi-thread-swatch').forEach(function (s) { s.classList.remove('senshi-thread-swatch--active'); });
        sw.classList.add('senshi-thread-swatch--active');
        var r = sw.querySelector('input[type="radio"]'); if (r) r.checked = true;
        updateStrapText();
      });
    });
  }

  function applyStrapTextStyle(colour) {
    if (!strapPreviewText) return;
    var st = (colour && strapTextStyles[colour]) || {};
    strapPreviewText.style.color = selectedThreadHex() || st.color || '';
    strapPreviewText.style.right = st.right || '';
    strapPreviewText.style.top = st.top || '';
    strapPreviewText.style.fontSize = st.fontSize || '';
  }
  function updateStrapText() {
    if (!strapPreviewText) return;
    var on = embToggle && embToggle.checked;
    var typed = embTextInput ? embTextInput.value : '';
    var shown = on ? (typed || STRAP_TEXT_PLACEHOLDER) : '';
    strapPreviewText.textContent = shown;
    strapPreviewText.setAttribute('data-text', shown);
    strapPreviewText.setAttribute('data-thread', selectedThreadName() || '');
    applyStrapTextStyle(selectedColour());
  }
  function updateStrapPreview() {
    if (!strapPreview || !strapPreviewImg) return;
    var on = embToggle && embToggle.checked;
    var colour = selectedColour();
    var src = colour ? strapImages[colour] : null;
    if (on && src) {
      strapPreviewImg.src = src;
      strapPreviewImg.alt = (colour || '') + ' strap';
      strapPreview.hidden = false;
    } else {
      strapPreview.hidden = true;
    }
    updateStrapText();
  }

  // ── Central update ──
  function updateSelection() {
    currentVariant = resolveVariant();

    var variantInput = form.querySelector('input[name="id"]');
    if (variantInput && currentVariant) variantInput.value = currentVariant.id;

    if (currentVariant) swapGallery(currentVariant.mediaId);

    if (printSelected) printSelected.textContent = selectedPrint() || '';
    if (strapSelected) strapSelected.textContent = selectedColour() || '';

    updatePrice();
    updateStrapPreview();
  }

  // ── Print swatches ──
  printSwatches.forEach(function (sw) {
    sw.addEventListener('click', function (e) {
      if (sw.dataset.available === 'false') { e.preventDefault(); return; }
      e.preventDefault();
      printSwatches.forEach(function (s) { s.classList.remove('senshi-swatch--active'); });
      sw.classList.add('senshi-swatch--active');
      var r = sw.querySelector('input[type="radio"]');
      if (r) r.checked = true;
      updateColourAvailability();
      updateSelection();
    });
  });

  // ── Strap colour swatches ──
  strapSwatches.forEach(function (sw) {
    sw.addEventListener('click', function (e) {
      if (sw.dataset.available === 'false') { e.preventDefault(); return; }
      e.preventDefault();
      strapSwatches.forEach(function (s) { s.classList.remove('senshi-swatch--active'); });
      sw.classList.add('senshi-swatch--active');
      var r = sw.querySelector('input[type="radio"]');
      if (r) r.checked = true;
      updateSelection();
    });
  });

  // ── Embroidery ──
  var embToggle = document.getElementById('senshi-embroidery-toggle');
  var embFields = document.getElementById('senshi-embroidery-fields');
  var embTextInput = document.getElementById('senshi-embroidery-text');
  var charCurrent = document.getElementById('senshi-char-current');

  function showEmbError(msg) { var el = document.getElementById('senshi-embroidery-error'); if (el) { el.textContent = msg; el.style.display = 'block'; } }
  function clearEmbError() { var el = document.getElementById('senshi-embroidery-error'); if (el) el.style.display = 'none'; }

  if (embToggle && embFields) {
    embToggle.addEventListener('change', function () {
      embFields.style.display = embToggle.checked ? 'block' : 'none';
      if (!embToggle.checked && embTextInput) {
        embTextInput.value = '';
        if (charCurrent) charCurrent.textContent = '0';
        clearEmbError();
      }
      if (embToggle.checked && embTextInput) embTextInput.focus();
      updatePrice();
      updateStrapPreview();
    });
  }

  if (embTextInput) {
    embTextInput.addEventListener('input', function () {
      var cursor = embTextInput.selectionStart;
      var original = embTextInput.value;
      var cleaned = stripNonEnglish(original);
      if (cleaned !== original) {
        embTextInput.value = cleaned;
        var removed = original.length - cleaned.length;
        embTextInput.setSelectionRange(cursor - removed, cursor - removed);
        showEmbError('English characters only (A-Z, 0-9, spaces and basic punctuation).');
      } else {
        clearEmbError();
      }
      if (charCurrent) charCurrent.textContent = embTextInput.value.length;
      updateStrapText();
    });
    embTextInput.addEventListener('paste', function (e) {
      e.preventDefault();
      var pasted = (e.clipboardData || window.clipboardData).getData('text');
      var cleaned = stripNonEnglish(pasted).substring(0, 10);
      var start = embTextInput.selectionStart;
      var end = embTextInput.selectionEnd;
      var current = embTextInput.value;
      var newVal = (current.substring(0, start) + cleaned + current.substring(end)).substring(0, 10);
      embTextInput.value = newVal;
      if (charCurrent) charCurrent.textContent = newVal.length;
      if (pasted !== cleaned) showEmbError('Non-English characters were removed from your paste.');
      else clearEmbError();
      updateStrapText();
    });
  }

  // ── Intercept add-to-cart ──
  form.addEventListener('submit', function (e) {
    if (!document.getElementById('senshi-bag-variants')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    handleAddToCart();
  }, true);

  var submitBtn = form.querySelector('[type="submit"], button[name="add"]');
  if (submitBtn) {
    submitBtn.addEventListener('click', function (e) {
      if (!document.getElementById('senshi-bag-variants')) return;
      e.preventDefault(); e.stopImmediatePropagation();
      handleAddToCart();
    }, true);
  }

  async function handleAddToCart() {
    if (!currentVariant) currentVariant = resolveVariant();
    if (!currentVariant) { showError('Please choose your options.'); return; }
    if (!currentVariant.available) { showError('This combination is sold out. Please pick another.'); return; }

    var embEnabled = embToggle ? embToggle.checked : false;
    var embText = embTextInput ? embTextInput.value.trim() : '';
    if (embEnabled && !embText) { showError('Please enter your embroidery text.'); if (embTextInput) embTextInput.focus(); return; }
    if (embEnabled && embText.length > 10) { showError('Embroidery text must be 10 characters or less.'); if (embTextInput) embTextInput.focus(); return; }
    if (embEnabled && !ENGLISH_ONLY.test(embText)) { showError('Embroidery text must use English characters only.'); if (embTextInput) embTextInput.focus(); return; }

    var items = [];
    var bagItem = { id: currentVariant.id, quantity: 1, properties: {} };
    var colour = selectedColour();
    if (colour) bagItem.properties['Strap Colour'] = colour;
    if (embEnabled && embText) bagItem.properties['Strap Embroidery'] = embText;
    if (currentVariant.image) bagItem.properties['_bag_image'] = currentVariant.image;
    items.push(bagItem);

    if (embEnabled && embText && config.embroideryVariantId) {
      var embProps = { 'Embroidery Text': embText };
      var threadName = selectedThreadName();
      if (threadName) embProps['Embroidery Colour'] = threadName;
      var embVariantId = (config.embroideryVariants && config.embroideryVariants[colour]) || config.embroideryVariantId;
      items.push({ id: embVariantId, quantity: 1, properties: embProps });
    }

    setLoading(true);
    try {
      await Cart.add(items);
      openCartDrawer();
    } catch (err) {
      showError(err.message || 'Error adding to cart. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  function openCartDrawer() {
    var cartModal = document.querySelector('.modal--cart, .popup--cart-notification');
    if (!cartModal) { window.location.href = '/cart'; return; }
    if (!cartModal.shown) cartModal.open();
    else if (cartModal.interval) { cartModal.interval.reset(); cartModal.interval.start(); }
  }

  function setLoading(loading) {
    var btn = form.querySelector('[type="submit"], button[name="add"], .js-add-to-cart');
    if (!btn) return;
    if (loading) { btn.setAttribute('disabled', 'disabled'); btn.classList.add('btn--loading', 'is-loading'); }
    else { btn.removeAttribute('disabled'); btn.classList.remove('btn--loading', 'is-loading'); }
  }

  function showError(msg) {
    var el = form.querySelector('.product-form__error, .js-form-error');
    if (el) { el.textContent = msg; el.style.display = 'block'; setTimeout(function () { el.style.display = 'none'; }, 5000); return; }
    alert(msg);
  }

  // ── Initial paint ──
  updatePrintAvailability();
  updateColourAvailability();
  updateSelection();
})();
